import browserUpdate from 'browser-update';

window.checkBrowserVersion = () => {
  browserUpdate({
    required: {
      i:12,
      e:-4,
      f:-3,
      o:-3,
      s:-1,
      c:-3
    },
    insecure: true,
    unsupported: true,
    reminder: 0, // show until hidden
    reminderClosed: 168, // then keep hidden for 7 days
    style: "corner",
    api: 2019.06,
    test: false,
    onshow: () => {
      if(window.track) {
        window.track('BrowserUpdate', 'outdated_version_dialog', 'Browser version outdated dialog');
      }
    }
  });
}

$(() => {
  window.checkBrowserVersion();
})
